import React, { useEffect, useState, useRef, useContext } from "react";
import { useDispatch } from "react-redux";
import { Alert, Button } from "reactstrap";
import ArtistsTable from "../../components/artistsTable";
import Pagination from '../../components/pagination/pagination';
import TableModal from "../../components/tableModal";
import ViewLayout from "../../components/viewLayout";
import { useFetch } from "../../utils/fetchHook";
import { StateContext } from "../../utils/context";

import { getCookie } from "../../jwt/_helpers/cookie";
import TableHelper from "../../components/tableHelper";
import ModuleAccessDeniedAlert from "../../components/moduleAccessDeniedAlert";
import { setArtists, deleteArtist } from "../../redux/artists/action";
import { getArtistMockExportPayload } from "../../utils/artistDemoHelpers";
import { isCopyMockDataEnabled } from "../../utils/demoConfig";

const Artists = props => {
  const dispatch = useDispatch();
  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [deleteBody, setDeleteBody] = useState(false);
  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);
  const [mockCopyNotice, setMockCopyNotice] = useState("");

  const [forceUpdate, setForce] = useState(1);

  const handlerValues = { setSuccess, setError, forceUpdate, setForce };
  const [tableData, setTableData] = useState([]);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '', name: 'name', sort: 'name'});
  const [subUser, setSubUser] = useState('');
  const [subUserEndpoint, setSubUserEndpoint] = useState('');
  const [parentUserOnly, setParentUserOnly] = useState('');

  const token = getCookie("token");
  const {currentUser} = useContext(StateContext);

  const [apiData, error, loading] = useFetch(
    "GET",
    `artists/${subUserEndpoint}?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&search=${query}${parentUserOnly}`,
    token,
    false,
    forceUpdate
  );

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const tableProps = {
    tableData,
    defaultSorted
  };

  useEffect(() => {
    if (apiData?.detail === "Invalid page.") {
      setCurrentPage(1);
      return;
    }

    if (apiData) {
      if(apiData.count) {
        setDataCount(apiData.count);
      }
      if(apiData.results) {
        setTableData(apiData.results);
        dispatch(setArtists(apiData.results));
      }
    }
  }, [apiData, dispatch]);

  
  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name, subUser]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  const handleCopyMockData = () => {
    const payload = getArtistMockExportPayload();
    navigator.clipboard
      .writeText(JSON.stringify(payload, null, 2))
      .then(() => setMockCopyNotice("Mock data copied to clipboard."))
      .catch(() => setMockCopyNotice("Could not copy mock data."));
  };

  const showCopyMockData = isCopyMockDataEnabled();

  return (
    <>
      {showCopyMockData && (
        <Alert color="light" className="mb-3 py-2">
          <Button size="sm" color="primary" onClick={handleCopyMockData}>
            Copy mock data
          </Button>
          {mockCopyNotice && (
            <span className="text-muted ml-2">{mockCopyNotice}</span>
          )}
          <small className="d-block text-muted mt-1">
            Exports current artist rows as JSON (paste to update seed data).
          </small>
        </Alert>
      )}
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          { 
            (!currentUser.artists) &&
            <ModuleAccessDeniedAlert module="artists" />
          }
          {
            (currentUser.artists) &&
            <>
              <ViewLayout title={"Your artists list"}>
                <ArtistsTable
                  {...tableProps}
                  setToggleModal={setToggleModal}
                  setDataModal={setDataModal}
                  setDeleteBody={setDeleteBody}
                  forceUpdate={forceUpdate}
                  searchQuery={{setQuery, query, ordering, setOrdering}}
                  subUserData={{subUser, setSubUser, subUserEndpoint, setSubUserEndpoint, setParentUserOnly}}
                  />
              </ViewLayout>
              <Pagination pagination={paginationProps}/>
            </>
          }
        </div>
      )}

      {dataModal && (
        <TableModal
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          values={handlerValues}
          title={
            deleteBody ? (!dataModal.can_be_deleted? `Artist ${dataModal.name} can't be deleted`: `Delete ${dataModal.name}?`) : `Edit ${dataModal.name}?`
          }
          body={
            deleteBody? (
              !dataModal.can_be_deleted?
                `Artist ${dataModal.name} can't be deleted as they already have Track(s)/Release(s) associated with them.`:
                "Are you really sure you really want to delete this artist? This action could detach your artist from the assigned release."
            ): "Are you really sure you want to change your artist name? This could have an effect on release metadata."
          }
          apiURL={`artists/${dataModal.id}/`}
          bodyID={dataModal.id}
          deleteBody={deleteBody}
          can_be_deleted={dataModal.can_be_deleted}
          onDeleteSuccess={
            deleteBody && dataModal?.id != null
              ? () => dispatch(deleteArtist(dataModal.id))
              : undefined
          }
        />
      )}
      {success && <Alert color="success">Artist has been removed!</Alert>}
      {errorPut && (
        <Alert color="danger">
          Something went wrong! Please refresh page and try again!
        </Alert>
      )}
    </>
  );
};

export default Artists;
